import { Box, HStack, MenuItem } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { FeedReportMenuItem } from "src/components/feed-card/context-menu/feed-report-menu-item";
import { IconFilledStar, IconOutlineStar } from "src/components/icons";
import { useUnderlyingFollowing } from "src/hooks/following/use-underlying-following";
import { useWikifolioFollowing } from "src/hooks/following/use-wikifolio-following";
import { EnumTaggedEntityType } from "../types/enums";
import { TFeedCardTaggedEntity } from "../types/feed-card";

interface IFeedCardContextMenuItemProps {
    taggedEntity: TFeedCardTaggedEntity;
}

export const FeedCardContextMenuItem = ({ taggedEntity }: IFeedCardContextMenuItemProps) => {
    const { entityType, entityId } = taggedEntity;

    switch (entityType) {
        case EnumTaggedEntityType.Wikifolio:
            return <WikifolioMenuItem wikifolioId={entityId} />;
        case EnumTaggedEntityType.Underlying:
            return <UnderlyingMenuItem underlyingIsin={entityId} />;
        case EnumTaggedEntityType.Comment:
            return <FeedReportMenuItem entityId={entityId} />;
        default:
            return <UnsupportedMenuItem entityType={entityType} />;
    }
};

interface IWikifolioMenuItemProps {
    wikifolioId: string;
}

const WikifolioMenuItem = ({ wikifolioId }: IWikifolioMenuItemProps) => {
    const { isFollowed, toggleIsFollowed } = useWikifolioFollowing(wikifolioId);
    const { t } = useTranslation("common");

    return (
        <MenuItem onClick={toggleIsFollowed}>
            <HStack>
                {isFollowed ? <IconFilledStar boxSize={3} /> : <IconOutlineStar boxSize={3} />}
                <Box>
                    {t("wikifolio")} {t(isFollowed ? "unfollow" : "follow", { ns: "feed" })}
                </Box>
            </HStack>
        </MenuItem>
    );
};

interface IUnderlyingMenuItemProps {
    underlyingIsin: string;
}

const UnderlyingMenuItem = ({ underlyingIsin }: IUnderlyingMenuItemProps) => {
    const { isFollowed, toggleIsFollowed } = useUnderlyingFollowing(underlyingIsin);
    const { t } = useTranslation(["common", "feed"]);

    return (
        <MenuItem onClick={toggleIsFollowed}>
            <HStack>
                {isFollowed ? <IconFilledStar boxSize={3} /> : <IconOutlineStar boxSize={3} />}
                <Box>
                    {t("underlying")} {t(isFollowed ? "unfollow" : "follow", { ns: "feed" })}
                </Box>
            </HStack>
        </MenuItem>
    );
};

const UnsupportedMenuItem = ({}: { entityType: never }) => null;
